import { render, staticRenderFns } from "./ObdTalkParamV2.vue?vue&type=template&id=05be6dd6&"
import script from "./ObdTalkParamV2.vue?vue&type=script&lang=js&"
export * from "./ObdTalkParamV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports